import ActionCardGridView from "@/components/actions/ActionCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { LayoutContext } from "@/lib/models";
import { Action, ActionService } from "@/services/ActionService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaActionListPage: React.FC = () => {
  const [actionList, setActionsList] = useState<Action[]>([]);
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Area: ${areaName} Tasks`);
    }, [areaName, setPageName]);

  useEffect(() => {
    ActionService
      .getByAreaId(params.areaId!)
      .then(setActionsList);
  }, [params.areaId]);

  return (
    <div className="container mx-auto p-4">
      <ActionCardGridView actionsList={actionList} title={`Area: ${areaName}`} />
    </div>
  );
};

export default AreaActionListPage;
